jQuery(document).ready(function() {
    jQuery('.podcast__episode__transcript').each(function() {
        const wrapper = jQuery(this);
        const content = wrapper.find('.content');
        const fullText = content.html();
        const showMoreBtn = wrapper.find('.show-more-button');
        const showLessBtn = wrapper.find('.show-less-button');
        
        // Function to truncate text
        function truncateContent() {
            const truncated = fullText.substring(0, 550) + '...';
            content.html(truncated);
            showMoreBtn.css('display', 'flex');
            showLessBtn.css('display', 'none');
        }
        
        // Initial setup
        if (fullText.length > 550) {
            truncateContent();
        } else {
            showMoreBtn.css('display', 'none');
            showLessBtn.css('display', 'none');
        }
        
        // Show more button click
        showMoreBtn.on('click', function() {
            content.html(fullText);
            showMoreBtn.css('display', 'none');
            showLessBtn.css('display', 'flex');
        });
        
        // Show less button click
        showLessBtn.on('click', function() {
            truncateContent();
        });
    });
});
